module.exports = __webpack_public_path__ + "static/media/image_24.fb8191d5.png";